module.exports = new __parcel__URL__("level_circle.40cca3b6.png").toString();